import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { PortalPage } from './pages/PortalPage';
import { LoginPage } from './pages/LoginPage';
import { CaapRoutes } from './features/caap/routes';
import { DeficitsRoutes } from './features/deficits/routes';
import { CommunicationRoutes } from './features/communication/routes';

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <PortalPage />
          </ProtectedRoute>
        }
      />
      <Route path="/caap/*" element={<CaapRoutes />} />
      <Route path="/deficits/*" element={<DeficitsRoutes />} />
      <Route path="/communication/*" element={<CommunicationRoutes />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
